import {type CityImprovementTypes} from '@colonist/game-states'
import {UIGameCityImprovementTrackerMetropolisTriangle} from
    '../UIGameCityImprovementTrackerMetropolisTriangle/UIGameCityImprovementTrackerMetropolisTriangle.tsx'
import {UIGameCityImprovementTrackerSquare} from '../UIGameCityImprovementTrackerSquare/UIGameCityImprovementTrackerSquare.tsx'
import styles from './UIGameCityImprovementTrackerColumn.module.scss'
import clsx from 'clsx'
import React from 'react'

export interface UIGameCityImprovementTrackerColumnProps {
    cityImprovementType: CityImprovementTypes
    hasMetropolis: boolean
    level: number
    className?: string
}

export function UIGameCityImprovementTrackerColumn({
    cityImprovementType,
    hasMetropolis,
    level,
    className,
}: UIGameCityImprovementTrackerColumnProps) {
    return (
        <div className={clsx(styles.container, className)}>
            <UIGameCityImprovementTrackerMetropolisTriangle
                cityImprovementType={cityImprovementType}
                className={clsx(styles.triangleWrapper, {[styles.hidden]: !hasMetropolis})}
            />
            {[4, 3, 2, 1, 0].map((threshold) => (
                <UIGameCityImprovementTrackerSquare
                    active={level > threshold}
                    cityImprovementType={cityImprovementType}
                    key={threshold}
                />
            ))}
        </div>
    )
}
